import React, { useEffect, useState } from "react";
import { ScrollView, StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";

import Container from "../../components/Container";
import Header from "../../components/Header";
import Button from "../../components/Button";
import StickyFooter from "../../components/StickyFooter";
import ProcedureLocationList from "../../components/ProcedureLocationList";
import { colors } from "../../theme";

const styles = StyleSheet.create({
  container: { backgroundColor: colors.black, flex: 1 },
  scrollView: { paddingHorizontal: 20, flex: 1 },
});

type Props = { navigation: any };

const ServiceCategorySelectionScreen: React.FC<Props> = ({ navigation }) => {
  const { params } = useRoute<any>();
  const { store, serviceType } = params || {};
  const categories = serviceType?.categories || [];
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  // A type with just one category (e.g. Permanent Makeup's "All") doesn't
  // need its own picking step -- go straight to the service list.
  useEffect(() => {
    if (categories.length === 1) {
      navigation.replace("ServiceSelection", {
        store,
        serviceType,
        serviceTypeCategory: categories[0],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (categories.length <= 1) return null;

  return (
    <SafeAreaView style={styles.container} edges={["right", "bottom", "left"]}>
      <Container>
        <ScrollView style={styles.scrollView}>
          <Header
            title={`${serviceType?.name} location`}
            description={`Start by selecting the location for your ${serviceType?.name?.toLowerCase()}.`}
          />
          <ProcedureLocationList
            serviceType={serviceType}
            locations={categories}
            selectedLocation={selectedCategory}
            onSelect={setSelectedCategory}
          />
        </ScrollView>
      </Container>
      <StickyFooter>
        <Button
          title="Next"
          disabled={!selectedCategory}
          onPress={() =>
            navigation.navigate("ServiceSelection", {
              store,
              serviceType,
              serviceTypeCategory: selectedCategory,
            })
          }
        />
      </StickyFooter>
    </SafeAreaView>
  );
};

export default ServiceCategorySelectionScreen;
